import { FC, Dispatch, SetStateAction, ChangeEvent } from 'react'
import { ApplicantData, InsuranceTypeData } from '../../../dtos/applicationData'
import {
  DefaultTitle, 
  DefaultSubtitle,
  HelperButton,
  FormContainer,
  OnboardingNewApplicationFirmAdminCheckboxContainer
} from '../../../components/application/defaultComponents'
import StandardInput from '../../../components/basic/StandardInput'
import StandardCheckbox from '../../../components/basic/StandardCheckbox'

interface ApplicantNameProps {
  applicantData: Partial<ApplicantData>;
  setApplicantData: Dispatch<SetStateAction<Partial<ApplicantData>>>;
  insuranceType: InsuranceTypeData;
}

const ApplicantName: FC<ApplicantNameProps> = ({ applicantData, setApplicantData, insuranceType }) => {
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target
    setApplicantData(prev => ({ ...prev, [name]: value }))
  }
  
  return (
    <>
      <DefaultTitle>First, let’s get your name.</DefaultTitle>
      <DefaultSubtitle>
        If you’d like to provide your full legal name we can use this<br />
        to identify you and prefill information.
      </DefaultSubtitle>
      <FormContainer>
        <StandardInput 
          label="First Name"
          name="firstName"
          value={applicantData.firstName}
          onChange={handleInputChange}
        />
        <StandardInput 
          label="Last Name" 
          name="lastName"
          value={applicantData.lastName}
          onChange={handleInputChange}
        />
        <OnboardingNewApplicationFirmAdminCheckboxContainer isJudge={insuranceType === 'JUDGE'}>
          <StandardCheckbox 
            label={
              insuranceType === 'LAWYER' ?
              'I am a Firm Administrator' :
              'I am a Court Administrator, Court Coordinator, County Auditor, or other related judicial position.'
            }
            checked={applicantData.isFirmAdministrator} 
            onChange={() => setApplicantData(prev => ({ ...prev, isFirmAdministrator: !prev.isFirmAdministrator }))} 
            variation='small'
          />
        </OnboardingNewApplicationFirmAdminCheckboxContainer>
      </FormContainer>
    </>
  )
}

export default ApplicantName